// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluatePublicationFinderPage-cls1_LKT","cls2":"EvaluatePublicationFinderPage-cls2_Nxq EvaluatePublicationFinderPage-cls1_LKT"};